import { render, staticRenderFns } from "./OutputFieldBase.vue?vue&type=template&id=49948d24&"
import script from "./OutputFieldBase.vue?vue&type=script&lang=ts&"
export * from "./OutputFieldBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports